import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiUploadCloud, FiCamera, FiArrowLeft, FiTrash2, FiX } from "react-icons/fi";
import { useTranslation, Trans } from "react-i18next";
import * as pdfjsLib from 'pdfjs-dist';
import "./documentUploadPage.sass";
import { apiUser } from "../basedata/apiCall";
import { useStep } from "../context/StepContext"
import ModalInfo from "../components/Modal/ModalInfo";


// well, sthepany needs to work on this
const WaFiUploadCloud = FiUploadCloud as React.ComponentType<React.SVGProps<SVGSVGElement>>;
const WaFiCamera = FiCamera as React.ComponentType<React.SVGProps<SVGSVGElement>>;
const WaFiArrowLeft = FiArrowLeft as React.ComponentType<React.SVGProps<SVGSVGElement>>;
const WaFiTrash2 = FiTrash2 as React.ComponentType<React.SVGProps<SVGSVGElement>>;
const WaFiX = FiX as React.ComponentType<React.SVGProps<SVGSVGElement>>;


pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

const DocumentUploadPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { setStep } = useStep();
    const [isSending, setIsSending] = useState(false);
    const [hoverPhoto, setHoverPhoto] = useState(false);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [selectedFileName, setSelectedFileName] = useState<string | null>(null);
    const [uploadComplete, setUploadComplete] = useState(false);
    const [previewUrl, setPreviewUrl] = useState<string | undefined>();
    const [loadingProgress, setLoadingProgress] = useState<number>(0);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const uploadIntervalRef = useRef<NodeJS.Timeout | null>(null);
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    

    const closeModal = () => {
        setIsSuccessModalOpen(false);

        if (uploadIntervalRef.current) {
            clearInterval(uploadIntervalRef.current);
            uploadIntervalRef.current = null;
        }

        setSelectedFile(null);
        setSelectedFileName(null);
        setUploadComplete(false);
        setIsLoading(false);
        setLoadingProgress(0);
        setPreviewUrl(undefined);

        const fileInput = document.getElementById("file-upload") as HTMLInputElement;
        if (fileInput) {
            fileInput.value = "";
        }
    };

    const handleSend = async () => {
        if (!selectedFile) return;

        setIsSending(true);

        try {
            const base64 = await fileToBase64(selectedFile);

            const _upload_response = await apiUser.post('/biometry/onboarding/document/upload', {
            originToken: sessionStorage.getItem('token') || 'na',
            document: base64,
            });


            if (_upload_response?.data.success === true && _upload_response?.data.message === 'done') {
              return window.location.href = '/success';
            }

            if (!_upload_response?.data.success) {
                  setUploadComplete(false);
                  setIsSuccessModalOpen(true);
            }

            setUploadComplete(true);
            setIsSuccessModalOpen(true);
        } catch (err) {
            console.error(err);
            setUploadComplete(false);
            setIsSuccessModalOpen(true);
        } finally {
            setIsSending(false);
        }
    };


  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setSelectedFile(file);
    setSelectedFileName(file.name);
    setIsLoading(true);
    setUploadComplete(false);
    setLoadingProgress(0);

    let progress = 0;

    uploadIntervalRef.current = setInterval(() => {
      progress += 10;
      setLoadingProgress(progress);
      if (progress >= 100) {
        clearInterval(uploadIntervalRef.current!);
        uploadFileToServer(file);
      }
    }, 200);
  };

  const fileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  const renderPdfThumbnail = async (file: File): Promise<string> => {
    if (file.type !== 'application/pdf') return '';
    const arrayBuffer = await file.arrayBuffer();
    const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
    const page = await pdf.getPage(1);

    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d')!;
    const viewport = page.getViewport({ scale: 0.5 });

    canvas.height = viewport.height;
    canvas.width = viewport.width;

    await page.render({ canvasContext: context, viewport }).promise;
    return canvas.toDataURL();
  };

    const uploadFileToServer = async (file: File) => {
      return console.log('_path')
    };

    const handleRemoveFile = () => {
        if (uploadIntervalRef.current) {
            clearInterval(uploadIntervalRef.current);
            uploadIntervalRef.current = null;
        }

        setSelectedFile(null);
        setSelectedFileName(null);
        setUploadComplete(false);
        setIsLoading(false);
        setLoadingProgress(0);
        setPreviewUrl(undefined);

        const fileInput = document.getElementById("file-upload") as HTMLInputElement;
        if (fileInput) {
            fileInput.value = "";
        }
    };

    useEffect(() => {
      setStep(2);
    }, []);

     return (
        <div className="doc-upload-page">
            <h1 className="doc-upload-title">{t("document_upload_page.title")}</h1>

            <div className="doc-upload-card">
                <div className="doc-upload-icon-wrapper">
                <WaFiUploadCloud className="doc-upload-icon-upload" />
                </div>

                {!selectedFile && (
                <div className="doc-upload-text-container">
                    <h2 className="doc-upload-subtitle">{t("document_upload_page.upload_title")}</h2>
                    <p className="doc-upload-description">
                    <Trans
                        i18nKey="document_upload_page.upload_description"
                        components={{ bold: <strong /> }}
                    />
                    </p>
                    <p className="doc-upload-format">{t("document_upload_page.upload_format")}</p>
                </div>
                )}

                {selectedFile && (
                <div className="doc-upload-box">
                    <div className="doc-upload-header">
                        {uploadComplete && (
                            <img
                            src={previewUrl}
                            alt="thumbnail"
                            className="doc-upload-thumbnail"
                            />
                        )}

                        <div className="doc-upload-info-stacked">
                            <p className="doc-upload-filename">{selectedFileName}</p>
                            {isLoading ? (
                            <p className="doc-upload-meta">
                                {loadingProgress}% • {Math.max(1, Math.ceil((100 - loadingProgress) / 10))} {t("step.second")}
                            </p>
                            ) : (
                            uploadComplete && (
                                <p className="doc-upload-success-text">{t("step.upload")}</p>
                            )
                            )}
                        </div>
                    </div>
                    <div className="doc-upload-progress-wrapper">
                    <div className="doc-upload-progress-bar">
                        <div
                        className="doc-upload-progress-bar-fill"
                        style={{ width: `${loadingProgress}%` }}
                        ></div>
                    </div>

                    <button
                        className={`doc-upload-delete-button ${isLoading ? "is-x" : "is-trash"}`}
                        onClick={handleRemoveFile}
                    >
                        {isLoading ? <WaFiX /> : <WaFiTrash2 />}
                    </button>
                    </div>
                </div>
                )}

                <input
                    type="file"
                    id="file-upload"
                    accept="application/pdf,.pdf"
                    onChange={handleFileChange}
                    capture={false}
                    style={{ display: "none" }}
                />


                <button
                className="doc-upload-button"
                onClick={() => {
                    if (!uploadComplete) {
                    document.getElementById("file-upload")?.click();
                    } else {
                    handleSend();
                    }
                }}
                disabled={isSending}
                >
                {!uploadComplete
                    ? t("document_upload_page.upload_button")
                    : t("step.send")}
                </button>
            </div>

            <button
                className={`doc-upload-photo-button ${hoverPhoto ? "hovered" : ""}`}
                onClick={() => {
                setHoverPhoto(true);
                setTimeout(() => {
                    navigate("/mobile-document?step=document_front");
                }, 100);
                }}
                onMouseEnter={() => setHoverPhoto(true)}
                onMouseLeave={() => setHoverPhoto(false)}
            >
                {hoverPhoto ? (
                <WaFiArrowLeft className="doc-upload-photo-icon" />
                ) : (
                <WaFiCamera className="doc-upload-photo-icon" />
                )}
                <span>{t("document_upload_page.photo_button")}</span>
            </button>

            <ModalInfo isOpen={isSuccessModalOpen} onClose={closeModal} overlayClassName="ModalInfoOverlay">
                <div className="modal-document-handler">
                    <h1 className="modal-title">{t("modal_document_handler.title")}</h1>
                    <p className="modal-quote primary">{t("modal_document_handler.quote")}</p>
                    <p className="modal-quote">{t("modal_document_handler.quote_2")}</p>
                    <button className="btn_send_document modal-action-button" onClick={closeModal}>
                    <span>{t("modal_document_handler.call_to_action")}</span>
                    </button>
                </div>
            </ModalInfo>
        </div>
    );
};

export default DocumentUploadPage;